// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './common-tracking-analytics';

const api = new APICore();

const BASE_URL = config.TRACKING_STATUS_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getNoShipments(query): any {
    const endpoint = '/no_shipments';
    return makeApiCall(endpoint, query);
}

function getNoShipmentsWithTrackingEvents(query): any {
    const endpoint = '/no_shipments_with_tracking_events';
    return makeApiCall(endpoint, query);
}

function getNoDelivered(query): any {
    const endpoint = '/no_delivered';
    return makeApiCall(endpoint, query);
}

function getNoUndelivered(query): any {
    const endpoint = '/no_undelivered';
    return makeApiCall(endpoint, query);
}

function getNoExceptions(query): any {
    const endpoint = '/no_exceptions';
    return makeApiCall(endpoint, query);
}

function getTrackingStatus(query): any {
    const endpoint = '/tracking_statuses';
    return makeApiCall(endpoint, query);
}

function getTrackingStatusByTimeframe(query): any {
    const endpoint = '/tracking_statuses_by_timeframe';
    return makeApiCall(endpoint, query);
}

function getTrackingStatusSummary(query): any {
    const endpoint = '/tracking_statuses_summary';
    return makeApiCall(endpoint, query);
}

export {
    getNoShipments,
    getNoShipmentsWithTrackingEvents,
    getNoDelivered,
    getNoUndelivered,
    getNoExceptions,
    getTrackingStatus,
    getTrackingStatusByTimeframe,
    getTrackingStatusSummary,
};
